// extracted by mini-css-extract-plugin
module.exports = {"buttonMinimal":"buttonMinimal_buttonMinimal__rkvlx"};